angular.module('Itao.IndicatorMap').directive('textfield', function (mapConfig, $rootScope, $timeout) {
  'use strict';

  /**
   * Generates Math.random-based unique IDs
   * @returns {string}
   */
  function generateID() {
    // https://gist.github.com/gordonbrander/2230317
    return Math.random().toString(36).substr(2, 9);
  }
  return {
    templateUrl: mapConfig.templateBasePath + 'textfield.html',
    restrict: 'E',
    scope: {
      config: '=',
      dimensionX: '@',
      dimensionY: '@'
    },
    controller: function($scope) {
      $scope.uniqueIdentifier = generateID();
      $scope.disableEditMode = !angular.copy(mapConfig.registeredUserMode);
      $scope.loadLastBookmark = function() {
        $rootScope.$emit('loadLastLoadedBookmark');
      };
      if(!angular.copy(mapConfig.registeredUserMode)) {
        // this timeout is needed when widgets are loaded after the textwidget in the same bookmark
        $timeout(function(){
          $rootScope.$emit('startWatchingBookmarkConfig');
          $rootScope.$on('bookmarkConfigChanged', function() {
            $scope.showConfigChangedText = true;
          });
        }, 0);

      }
    },
    link: function(scope, element){
      scope.toggleRenderContent = function() {
        scope.renderContent = !scope.renderContent;
      };

      var smallDimensionClass = 'textfield-small';
      scope.$watch('dimensionX', function(newValue) {
        var dimension = parseInt(newValue);
        if(dimension === 2) {
          element.addClass(smallDimensionClass);
        } else {
          element.removeClass(smallDimensionClass);
        }
      });
    }
  };
});
